import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getShopProducts } from "../../actions/shop";
import { Spinner, ImgIcon } from "../../assets";
import ProductManager from "./ProductManager";
import { hidden, visible, edit } from "../../assets/icons";

export default function Products() {

	const dispatch = useDispatch();
	const {
		products, loading
	} = useSelector(state => state.shop);

	useEffect(() => {
		dispatch(getShopProducts());
	}, [dispatch]);

	if (loading && !products.length) return <Spinner
		color={"#000000"}
		size={50}
		fullscreen={true}
	/>;

	return <div className="products">
		{Boolean(products && products.length) && <section>
			<h4>Your products</h4>
			<div className="inner v-middle">
				This is the list of currently active products on your <b>orderabl</b> shop. Your shop will be updated automatically as soon as you hit 'save' on one of the products.
				<br /><br />
				If you want to edit an existing product, click the <EditIcon size={20} /> icon. If you want to hide a product from your shop so customers can't buy it, click the <VisibleIcon size={20} /> icon. If you want to make that product available again, click the <HiddenIcon size={20} /> icon.
			</div>
			<br /><br />
			<div className="inner flexy legend">
				<div className="legend-item v-middle" style={{ whiteSpace: "pre" }}>
					<HiddenIcon size={30} />
					<span style={{ marginLeft: 10 }}>
						Hidden product
					</span>
				</div>
				<div className="legend-item v-middle" style={{ whiteSpace: "pre" }}>
					<VisibleIcon size={30} />
					<span style={{ marginLeft: 10 }}>
						Available product
					</span>
				</div>
			</div>
			<br /><br />
		</section>}
		<section>
			<ProductManager />
		</section>
	</div>
}


const HiddenIcon = ({ size }) => <ImgIcon
	src={hidden}
	size={size}
	iconSize={"70%"}
	bg={"#f7f7f7"}
/>

const VisibleIcon = ({ size }) => <ImgIcon
	src={visible}
	size={size}
	iconSize={"70%"}
	className="brand-bg"
/>

const EditIcon = ({ size }) => <ImgIcon
	src={edit}
	size={size}
	iconSize={"70%"}
	bg={"#f7f7f7"}
/>